export default {
  // 공통
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    add: '추가',
    search: '검색',
    reset: '초기화',
    export: '내보내기',
    import: '가져오기',
    upload: '업로드',
    download: '다운로드',
    submit: '제출',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    close: '닫기',
    refresh: '새로고침',
    loading: '로딩 중...',
    success: '작업 성공',
    error: '작업 실패',
    warning: '경고',
    info: '정보'
  },
  
  // 로그인
  login: {
    title: '사용자 로그인',
    username: '사용자명',
    password: '비밀번호',
    login: '로그인',
    logout: '로그아웃',
    loginSuccess: '로그인 성공',
    loginFailed: '로그인 실패',
    notLoggedIn: '로그인되지 않음...',
    systemTitle: '청화환경기술·수소발생기 관리시스템',
    welcomeTitle: '환영합니다 - 수소발생기 관리시스템',
    usernameMinLength: '사용자명은 최소 2자 이상이어야 합니다',
    passwordFormat: '비밀번호 형식이 올바르지 않습니다',
    verificationCode: '인증 코드 오류 (대소문자 구분)'
  },
  
  // 관리자 페이지
  admin: {
    title: '청화환경기술-관리시스템',
    dashboard: '대시보드',
    menu: '메뉴',
    logout: '로그아웃'
  },
  
  // 디바이스 관리
  device: {
    title: '디바이스 관리',
    list: '디바이스 목록',
    add: '디바이스 추가',
    edit: '디바이스 편집',
    delete: '디바이스 삭제',
    status: '디바이스 상태',
    type: '디바이스 유형',
    online: '온라인',
    offline: '오프라인',
    heartbeat: '하트비트 데이터',
    record: '작업 기록',
    activate: '활성화 기록',
    // 设备类型管理
    typeCode: '디바이스 유형 코드',
    typeName: '디바이스 유형 이름',
    selectOrganization: '조직을 선택하세요',
    typeCodePlaceholder: '유형 코드를 입력하세요',
    typeNamePlaceholder: '디바이스 유형 이름을 입력하세요',
    typeCodeRequired: '유형 코드는 필수입니다',
    typeNameRequired: '유형 이름은 필수입니다',
    addType: '유형 추가',
    editType: '유형 편집',
    deleteConfirm: '디바이스 유형 "{name}"을(를) 삭제하시겠습니까?',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    saveSuccess: '저장 성공',
    saveFailed: '저장 실패',
    getDataFailed: '데이터 가져오기 실패',
    organization: '조직',
    universal: '범용',
    defaultOutVol: '기본 출력량(광산기)',
    outVolRequired: '기본 출력량은 필수입니다',
    changeRule: '필터 교체 계산 규칙',
    filterAlgorithm: '필터 알고리즘',
    byVolume: '용량별',
    byTime: '시간별',
    none: '없음',
    ruleDescription: '필터 교체 계산 규칙:',
    volumeRule: '1: 용량으로 계산 (예: 1-4번 필터, 40000L마다 교체)',
    timeRule: '2: 시간으로 계산 (예: 1년, 60000L)',
    validHot: '첫 온수',
    validHotYes: '예',
    validHotNo: '아니오',
    changeValue: '필터 교체 값',
    changeValuePlaceholder: '필터 교체 값을 입력하세요',
    changeValueUnit: '단위',
    changeValueUnitMl: 'ml',
    changeValueUnitYear: '년',
    customSettings: '맞춤 설정',
    settingKey: '키',
    settingValue: '값',
    settingRemark: '비고',
    settingKeyPlaceholder: '키를 입력하세요',
    settingValuePlaceholder: '값을 입력하세요',
    settingRemarkPlaceholder: '비고를 입력하세요',
    addSettingRow: '행 추가',
    deleteSettingRow: '삭제',
    relatedOrg: '관련 조직',
    remark: '비고'
  },
  
  // 조직 관리
  org: {
    title: '조직 관리',
    list: '조직 목록',
    add: '조직 추가',
    edit: '조직 편집',
    delete: '조직 삭제',
    name: '조직명',
    code: '조직 코드',
    type: '조직 유형'
  },
  
  // 물 카드 관리
  card: {
    title: '물 카드 관리',
    list: '물 카드 목록',
    add: '물 카드 추가',
    bind: '물 카드 바인딩',
    unbind: '물 카드 언바인딩',
    import: '물 카드 가져오기',
    export: '물 카드 내보내기',
    serialNo: '시리얼 번호',
    cardNo: '카드 번호',
    status: '상태'
  },
  
  // 시스템 설정
  setting: {
    title: '시스템 설정',
    general: '일반 설정',
    security: '보안 설정',
    notification: '알림 설정'
  },
  
  // 데이터 통계
  stats: {
    title: '데이터 통계',
    tds: 'TDS 통계',
    volume: '물량 통계',
    usage: '사용 통계'
  },
  
  // 푸터
  footer: {
    copyright: '© 2023 - 청화환경기술유한공사 모든 권리 보유',
    icp: 'ICP 기록: ',
    techSupport: '© 기술 지원: 광저우 관군 수소 기술 유한공사'
  },
  
  // 오류 메시지
  error: {
    network: '네트워크 오류',
    server: '서버 오류',
    permission: '권한 부족',
    param: '매개변수 오류',
    notFound: '데이터를 찾을 수 없음',
    pageNotFound: '죄송합니다. 방문하신 페이지가 존재하지 않습니다'
  },
  
  // 메뉴 관련
  menu: {
    // 디바이스 관리
    equipment: '디바이스 및 필터 라이브러리',
    filterRecord: '필터 교체 기록',
    version: '홈 버전 라이브러리',
    dataQuery: 'TCP 데이터 쿼리',
    heartbeat: '하트비트 데이터',
    singleUse: '단회 사용 데이터',
    bindStats: '바인딩 통계',
    
    // 고객 관리
    customer: '고객 관리',
    agentCheck: '에이전트 검토',
    agentProfit: '에이전트 수익 관리',
    promotionRoute: '프로모션 경로 구성',
    partyType: '파티 타입 관리',
    
    // MQTT 데이터 쿼리
    mqttQuery: 'MQTT 데이터 쿼리',
    statusQuery: '상태 쿼리',
    outputRecord: '출력 기록 쿼리',
    debug: '디바이스 디버그 페이지',
    waterTotal: '총 물 출력 쿼리',
    
    // 시스템 관리
    adminAccount: '관리자 계정',
    deviceType: '디바이스 타입 관리',
    defaultSettings: '기본 시스템 설정',
    flowConfig: '물 흐름 개인화',
    waterConfig: '온도 물 구성',
    businessLog: '비즈니스 로그',
    
    // 결제 관리
    payment: '결제 관리',
    order: '주문 관리',
    statistics: '데이터 통계',
    waterPrice: '물 가격 구성',
    recharge: '충전'
  },

  // 파티 타입 관리
  orgLibConfig: {
    title: '파티 타입 관리',
    libName: '파티 이름',
    libNamePlaceholder: '파티 타입 이름을 입력하세요',
    libLevel: '파티 레벨',
    allLevels: '모든 레벨',
    level: '급',
    typeId: '타입 ID',
    typeName: '타입 이름',
    typeNamePlaceholder: '타입 이름을 입력하세요',
    typeLevel: '타입 레벨',
    parentType: '상위 타입',
    childCount: '하위 수',
    status: '상태',
    enabled: '활성화',
    disabled: '비활성화',
    unknown: '알 수 없음',
    none: '없음',
    remark: '비고',
    remarkPlaceholder: '비고를 입력하세요',
    createTime: '생성 시간',
    detail: '상세',
    edit: '편집',
    add: '추가',
    delete: '삭제',
    editType: '타입 편집',
    addSubType: '하위 타입 추가',
    typeNameRequired: '타입 이름을 입력하세요',
    typeLevelRequired: '타입 레벨을 선택하세요',
    deleteConfirm: '이 타입을 삭제하시겠습니까?',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    addSuccess: '추가 성공',
    updateSuccess: '업데이트 성공',
    saveFailed: '저장 실패',
    getDataFailed: '데이터 가져오기 실패',
    getDetailFailed: '상세 정보 가져오기 실패',
    getParentFailed: '상위 노드 정보 가져오기 실패',
    cannotEditRoot: '루트 노드는 편집할 수 없습니다',
    cannotDeleteRoot: '루트 노드는 삭제할 수 없습니다',
    hasChildrenCannotDelete: '이 노드에 하위 노드가 있어 삭제할 수 없습니다',
    maxLevelReached: '최대 8레벨까지 지원됩니다'
  },

  // 배너 관리
  banner: {
    title: '홈페이지 배너 관리',
    addBanner: '배너 추가',
    editBanner: '배너 편집',
    image: '이미지',
    linkUrl: '링크 URL',
    sort: '정렬',
    status: '상태',
    createTime: '생성 시간',
    enabled: '활성화',
    disabled: '비활성화',
    titlePlaceholder: '배너 제목을 입력하세요',
    titleRequired: '배너 제목은 필수입니다',
    imageRequired: '배너 이미지를 업로드하세요',
    linkUrlPlaceholder: '링크 URL을 입력하세요(선택사항)',
    sortPlaceholder: '정렬 값을 입력하세요. 숫자가 작을수록 앞에 표시됩니다',
    sortRequired: '정렬 값은 필수입니다',
    remark: '비고',
    remarkPlaceholder: '비고를 입력하세요',
    uploadImage: '이미지 업로드',
    viewImage: '이미지 보기',
    removeImage: '이미지 제거',
    uploadTip: '권장 크기: 1920x600px, JPG, PNG 형식 지원, 파일 크기 5MB 이하',
    uploadImageOnly: '이미지 파일만 업로드할 수 있습니다',
    uploadSizeLimit: '이미지 크기는 5MB를 초과할 수 없습니다',
    uploadSuccess: '업로드 성공',
    uploadFailed: '업로드 실패',
    noImage: '이미지 없음',
    deleteConfirm: '이 배너를 삭제하시겠습니까?',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    saveSuccess: '저장 성공',
    saveFailed: '저장 실패',
    updateSuccess: '업데이트 성공',
    updateFailed: '업데이트 실패',
    getListFailed: '배너 목록 가져오기 실패'
  },

  // 총 물 출력 쿼리
  waterTTL: {
    title: '총 물 출력 쿼리',
    equipmentId: '장비 ID',
    enterEquipmentId: '장비 ID를 입력하세요',
    organization: '소속 조직',
    allOrganizations: '모든 조직',
    equipmentIdColumn: '장비 ID',
    orgNameColumn: '소속 조직',
    volumeTTLColumn: '사용 유량·ml',
    waterRecord: '물 출력 기록',
    export: '내보내기',
    exportSuccess: '내보내기 성공',
    exportFailed: '내보내기 실패',
    getDataFailed: '데이터 가져오기 실패',
    getOrgListFailed: '조직 목록 가져오기 실패'
  },

  // 온도 물량 구성
  waterConfig: {
    title: '온도 물량 구성',
    waterType: '물 타입',
    allTypes: '모두',
    iceWater: '얼음물',
    normalWater: '상온 물',
    water45: '45℃ 물',
    water75: '75℃ 물',
    water95: '95℃ 물',
    status: '상태',
    allStatus: '모두',
    enabled: '활성화',
    disabled: '비활성화',
    waterMl: '대응 물량(ml)',
    waterMlPlaceholder: '대응 물량을 입력하세요',
    waterMlRequired: '대응 물량은 필수입니다',
    sort: '정렬',
    sortPlaceholder: '정렬 값을 입력하세요 (숫자가 작을수록 앞에 표시됩니다)',
    typeName: '물 타입',
    waterVolume: '대응 물량',
    createTime: '생성 시간',
    updateTime: '업데이트 시간',
    addConfig: '구성 추가',
    editConfig: '온도 물량 구성 편집',
    addConfigTitle: '온도 물량 구성 추가',
    typeRequired: '물 타입은 필수입니다',
    duplicateError: '이 물 타입과 대응 물량의 조합은 이미 존재합니다!',
    deleteConfirm: '삭제하시겠습니까? 삭제 후에는 복원할 수 없습니다!',
    statusConfirm: '이 구성을 {status}하시겠습니까?',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    saveSuccess: '저장 성공',
    saveFailed: '저장 실패',
    statusUpdateSuccess: '상태 업데이트 성공',
    statusUpdateFailed: '상태 업데이트 실패',
    getDataFailed: '데이터 가져오기 실패'
  },

  // WeChat 결제 로그 관리
  payLog: {
    title: 'WeChat 결제 로그 관리',
    payLogTab: '결제 로그',
    performanceTab: '성능 모니터링',
    statisticsTab: '데이터 통계',
    orderNo: '주문 번호',
    orderNoPlaceholder: '주문 번호를 입력하세요',
    logType: '로그 타입',
    allTypes: '모두',
    logTypePay: '결제',
    logTypeRefund: '환불',
    logTypeQuery: '조회',
    logTypeCallback: '콜백',
    logLevel: '로그 레벨',
    allLevels: '모두',
    logLevelInfo: '정보',
    logLevelWarn: '경고',
    logLevelError: '오류',
    apiType: 'API 타입',
    apiTypeUnifiedOrder: '통합 주문',
    apiTypeQuery: '주문 조회',
    apiTypeRefund: '환불 신청',
    minDuration: '최소 소요 시간(ms)',
    maxDuration: '최대 소요 시간(ms)',
    startDate: '시작 날짜',
    endDate: '종료 날짜',
    startDatePlaceholder: '시작 날짜',
    endDatePlaceholder: '종료 날짜',
    viewDetail: '상세 보기',
    export: '내보내기',
    exportSuccess: '내보내기 성공',
    exportFailed: '내보내기 실패',
    dateRangeRequired: '통계 날짜 범위를 선택하세요',
    logDetail: '로그 상세',
    logContent: '로그 내용',
    requestData: '요청 데이터',
    responseData: '응답 데이터',
    errorMsg: '오류 메시지',
    ipAddress: 'IP 주소',
    createTime: '생성 시간',
    duration: '소요 시간(ms)',
    status: '상태',
    statDate: '통계 날짜',
    totalOrders: '총 주문 수',
    successOrders: '성공 주문 수',
    failedOrders: '실패 주문 수',
    totalAmount: '총 금액(元)',
    successAmount: '성공 금액(元)',
    refundOrders: '환불 주문 수',
    refundAmount: '환불 금액(元)',
    successRate: '성공률',
    getDataFailed: '데이터 가져오기 실패'
  },

  // 물 가격 설정
  waterPriceConfig: {
    title: '물 가격 설정',
    configName: '설정 이름',
    configNamePlaceholder: '설정 이름을 입력하세요',
    configDesc: '설정 설명',
    configDescPlaceholder: '설정 설명을 입력하세요',
    waterVolume: '물량(L)',
    waterVolumePlaceholder: '물량을 입력하세요',
    basePrice: '기본 가격(元/L)',
    basePricePlaceholder: '기본 가격을 입력하세요',
    discount: '할인',
    discountPlaceholder: '할인을 입력하세요(0.01-1.00)',
    discountedUnitPrice: '할인 후 단가(元/L)',
    finalPrice: '최종 가격(元)',
    sortOrder: '정렬 순서',
    sortOrderPlaceholder: '정렬 순서를 입력하세요',
    status: '상태',
    allStatus: '모두',
    enabled: '활성화',
    disabled: '비활성화',
    enable: '활성화',
    disable: '비활성화',
    createTime: '생성 시간',
    updateTime: '업데이트 시간',
    createUser: '생성자',
    updateUser: '업데이트자',
    addConfig: '설정 추가',
    editConfig: '설정 편집',
    batchEnable: '일괄 활성화',
    batchDisable: '일괄 비활성화',
    waterVolumeRequired: '물량을 입력하세요',
    waterVolumeMin: '물량은 0보다 커야 합니다',
    basePriceRequired: '기본 가격을 입력하세요',
    basePriceMin: '기본 가격은 0 이상이어야 합니다',
    discountRequired: '할인을 입력하세요',
    discountRange: '할인은 0.01-1.00 사이여야 합니다',
    configNameRequired: '설정 이름을 입력하세요',
    deleteConfirm: '이 설정을 삭제하시겠습니까?',
    deleteSuccess: '삭제 성공',
    deleteFailed: '삭제 실패',
    saveSuccess: '저장 성공',
    saveFailed: '저장 실패',
    updateSuccess: '업데이트 성공',
    updateFailed: '업데이트 실패',
    statusChangeConfirm: '이 설정을 {status}하시겠습니까?',
    statusChangeSuccess: '상태 업데이트 성공',
    statusChangeFailed: '상태 업데이트 실패',
    batchEnableConfirm: '선택한 설정을 일괄 활성화하시겠습니까?',
    batchEnableSuccess: '일괄 활성화 성공',
    batchEnableFailed: '일괄 활성화 실패',
    batchDisableConfirm: '선택한 설정을 일괄 비활성화하시겠습니까?',
    batchDisableSuccess: '일괄 비활성화 성공',
    batchDisableFailed: '일괄 비활성화 실패',
    selectConfigs: '작업할 설정을 선택하세요',
    getListFailed: '가격 설정 목록 가져오기 실패'
  }
}
